import React from 'react';
import { CalendarDays } from 'lucide-react';
import ConsultationCalendar from './ConsultationCalendar';

const ScheduleConsultationSection = ({ label = 'Schedule a Call', title, subtitle }) => {
  return (
    <section className="relative py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="section-label mb-6">{label}</div>
        <div className="grid lg:grid-cols-[1.1fr_1fr] gap-8 items-start">
          <div>
            <h2 className="font-display text-3xl md:text-5xl font-semibold text-white tracking-tight leading-tight">
              {title || (<>Book a free <span className="gradient-text">30-minute consultation</span></>)}
            </h2>
            <p className="text-slate-400 mt-5 leading-relaxed max-w-lg">
              {subtitle || 'Pick any available date to schedule a call with our team. We\u2019ll follow up on your preferred contact to confirm the meeting details.'}
            </p>

            <div className="mt-8 space-y-4">
              <div className="flex items-start gap-3">
                <div className="h-9 w-9 rounded-xl bg-amber-500/10 border border-amber-500/25 flex items-center justify-center shrink-0">
                  <CalendarDays size={16} className="text-amber-400" />
                </div>
                <div>
                  <div className="text-white text-sm font-medium">Flexible scheduling</div>
                  <div className="text-slate-400 text-xs mt-0.5">Pick any weekday slot that suits you</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="h-9 w-9 rounded-xl bg-amber-500/10 border border-amber-500/25 flex items-center justify-center shrink-0">
                  <CalendarDays size={16} className="text-amber-400" />
                </div>
                <div>
                  <div className="text-white text-sm font-medium">No obligation</div>
                  <div className="text-slate-400 text-xs mt-0.5">A friendly conversation about your goals</div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <ConsultationCalendar />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ScheduleConsultationSection;
